import React from "react";
import * as Cookies from "js-cookie";

import "./AlreadyLoggedIn.css";
import { Redirect } from "react-router-dom";
import { useQueryString } from "../../../Hooks/useQueryString";
import loggedIn from "../../../GraphQL/Query/loggedIn";
import { useQuery } from "@apollo/client";

export const AlreadyLoggedIn = ({ children }) => {
  const { data } = useQuery(loggedIn, {
    fetchPolicy: "network-only",
  });
  const queryParams = useQueryString();
  const redirectParam = queryParams.get("redirect");
  const hasApplicationRole = Cookies.get("access_level");

  if (data?.loggedIn && hasApplicationRole) {
    if (redirectParam) {
      window.location.assign(redirectParam);
    }
    if (
      hasApplicationRole === "SUPERADMIN" ||
      hasApplicationRole === "DISTRIBUTOR"
    ) {
      return <Redirect to="/admin" />;
    } else if (hasApplicationRole === "CUSTOMER") {
      return <Redirect to="/login/apps" />;
    } else {
      return { children };
    }
  } else {
    return <>{children}</>;
  }
};
